export class UserDisplayService {
    getUserDisplayName(email: string, firstName: string | null = "", lastName: string | null = ""): string {
        if (!firstName && !lastName) {
            return email;
        }

        return `${firstName || ""} ${lastName || ""}`.trim();
    }
}
